const BASE_DEV_WEB = "http://localhost:3000";
const BASE_PROD_WEB = "https://dev.farexrides.com";

export const BASE_URL_WEB =
  process.env.NODE_ENV === "development" ? BASE_DEV_WEB : BASE_PROD_WEB;

export const websiteDetail = {
  title: "FareXRides",
  titleValue: "FareX Rides",
  email: "info@farexrides.com",
  countryCode: "+91",
  mobile: "8130418304",
  phoneNumber: "+91-8130418304",
  sharedTitle: "FareXRides is a global transportation app developed by #",
  quoteTitle: "FarexRides is a global transportation app developed by #",
  link: "https://www.farexrides.com",
  linkText: "www.farexrides.com",
  paymentDescription: "FarexRides booking website",
  address: "Essay Cabtech Pvt. Ltd., 1216, 12th Floor, DLF Galleria Tower, DLF Phase IV, Gurugram, Haryana 122009",
  addressData:
    "804, Agarwal Millennium Tower -1 Netaji Subhash Place Pitampura, new Delhi -110034",
};

export const websiteDetailUrl = {
  annoucement: `${BASE_URL_WEB}/announcement-detail`,
  article: `${BASE_URL_WEB}/article-detail`,
  blog: `${BASE_URL_WEB}/blog-detail`,
  imageURL: "https://fimages.farexrides.com/originals/",
  pushNotification:
    "https://fapis.farexrides.com/api/v1/push2/driver-android-ios-push-notification",
};

export const websiteSocialLinks = {
  facebook: "https://www.facebook.com/profile.php?id=61589383193902#",
  twitter: "https://x.com/#",
  linkedin: "https://linkedin.com/",
  instagram: "https://www.instagram.com/farexridesofficial?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
  youtube: "https://www.youtube.com/",
  pinterest: "https://in.pinterest.com/",
  android: "https://play.google.com/store/apps/details?id=com.rider.farex",
  ios: "https://apps.apple.com/in/app/farex-rides/id6741313272",
};

export const delayData = {
  androidFormDelay: 1500,
  adminFormDelay:1000,
}

export const defaultValues = {
minSeat:1,
maxSeat:10,
seatStep:1,
minPrice:1,
maxPrice:10000,
priceStep:10
}

export const CITY_ID = process.env.REACT_APP_CITY_ID;

export const TagColor = [
  "#EADBDD",
  "#FCD5CE",
  "#FFCAD4",
  "#FADDE1",
  "#FAEDCB"
]

export const mapLibraries = ['places']

// Farex Points - Fare breakdown constants
export const FARE_GST_PERCENT = 5;
export const FARE_ADVANCE_COMMISSION_PERCENT = 10; // Advance = (Base Fare × Commission %) + GST
export const FARE_COMPANY_COMMISSION_PERCENT = 10; // Alias for backward compatibility
export const FARE_PLATFORM_FEE_PERCENT = 10; // Fallback for trip card when estimate not loaded